import { useState } from 'react';
import { useTicks } from './useTick';
export function useTimeTicks(scale, direction, ref, options) {
    const { tickFormat = scale.tickFormat() } = options;
    const [ticks, setTicks] = useState([]);
    useTicks(scale, direction, ref, {
        ...options,
        setTicks,
        tickFormat,
    });
    return ticks;
}
//# sourceMappingURL=useTimeTicks.js.map